"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_PHONE_CODES = exports.COUNTRIES_BY_ISO2 = exports.COUNTRIES = void 0;
exports.isValidPhoneCode = isValidPhoneCode;
const tslib_1 = require("tslib");
const countries_json_1 = tslib_1.__importDefault(require("./countries.json"));
exports.COUNTRIES = countries_json_1.default.map(([name, , , , phoneCode, iso2]) => ({ name, phoneCode, iso2 }));
exports.COUNTRIES_BY_ISO2 = Object.fromEntries(exports.COUNTRIES.map((c) => [c.iso2, c]));
/** D-30: 后端校验 phoneCode 白名单,防止绕过 */
exports.VALID_PHONE_CODES = Array.from(new Set(exports.COUNTRIES.map((c) => c.phoneCode)));
function isValidPhoneCode(code) {
    return exports.VALID_PHONE_CODES.includes(code);
}
